import HttpService from '../base.service/HttpService'

export default class UserManagementService extends HttpService {
  getPgb (param) {
    const api = process.env.VUE_APP_API + '/manuser-dash/search'
    return this.get(param, api)
  }

  addData (param) {
    const api = process.env.VUE_APP_API + '/manuser-dash/add'
    return this.post(param, api)
  }

  // updateData (param, id) {
  //   const api = process.env.VUE_APP_API + '/master/field/F02-edit'
  //   return this.post(param, api, id)
  // }

  // deleteData (id) {
  //   const api = process.env.VUE_APP_API + '/master/field/F03-delete'
  //   return this.delete(id, api)
  // }
}
